<template>
    <div
        class="hidden lg:flex flex-col relative overflow-hidden p-12 xl:p-[75px] text-white"
        style="background: radial-gradient(circle at 90% 5%, rgba(103,232,249,0.5) 0%, rgba(34,211,238,0.18) 22%, transparent 48%), linear-gradient(135deg, #0891b2 0%, #0e7490 55%, #155e75 100%);"
    >
        <!-- Background risk-matrix illustration -->
        <div class="absolute -right-8 -bottom-10 w-[520px] opacity-[0.15] pointer-events-none">
            <svg viewBox="0 0 500 440" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    v-for="(cell, i) in matrixCells"
                    :key="i"
                    :x="cell.x"
                    :y="cell.y"
                    :width="cell.w"
                    :height="cell.h"
                    rx="6"
                    fill="white"
                    :fill-opacity="cell.o"
                    stroke="white"
                    stroke-opacity="0.28"
                    stroke-width="1"
                />
                <path d="M80 369 C 200 300, 320 200, 424 65" stroke="white" stroke-opacity="0.55" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="7 7" fill="none" />
                <circle cx="424" cy="65" r="5" fill="white" fill-opacity="0.7" />
                <circle cx="338" cy="141" r="5" fill="white" fill-opacity="0.7" />
                <circle cx="424" cy="141" r="5" fill="white" fill-opacity="0.7" />
                <circle cx="252" cy="217" r="5" fill="white" fill-opacity="0.7" />
                <circle cx="166" cy="293" r="5" fill="white" fill-opacity="0.7" />
                <circle cx="424" cy="293" r="5" fill="white" fill-opacity="0.7" />
                <circle cx="80" cy="369" r="5" fill="white" fill-opacity="0.7" />
                <circle cx="338" cy="369" r="5" fill="white" fill-opacity="0.7" />
                <text x="20" y="24" fill="white" fill-opacity="0.6" font-size="15" font-family="ui-monospace, monospace">∑x²</text>
                <text x="235" y="24" fill="white" fill-opacity="0.6" font-size="15" font-family="ui-monospace, monospace">P(lesão)</text>
                <text x="470" y="80" fill="white" fill-opacity="0.6" font-size="16" font-family="ui-monospace, monospace">σ</text>
                <text x="466" y="300" fill="white" fill-opacity="0.6" font-size="16" font-family="ui-monospace, monospace">x̄</text>
                <text x="358" y="430" fill="white" fill-opacity="0.6" font-size="14" font-family="ui-monospace, monospace">r² = 0.91</text>
                <text x="20" y="430" fill="white" fill-opacity="0.6" font-size="14" font-family="ui-monospace, monospace">n = 128</text>
            </svg>
        </div>

        <!-- Content -->
        <div class="relative z-10">
            <h2 class="text-[34px] xl:text-[42px] font-normal leading-[1.24] tracking-tight max-w-[600px] mb-4">
                Avalie. Trate. Decida. Previna Lesões Esportivas.
            </h2>
            <p class="text-[17px] leading-[1.6] max-w-[540px] text-white/85">
                A SIRIMMATRIX transforma avaliações clínicas em decisões inteligentes, ajudando você a identificar riscos, monitorar a evolução do atleta e tomar decisões mais seguras, rápidas e baseadas em evidências.
            </p>
            <div class="space-y-2.5 mt-5">
                <div v-for="highlight in highlights" :key="highlight" class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-cyan-300 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                    <span class="text-[16px] font-medium text-white/95">{{ highlight }}</span>
                </div>
            </div>
        </div>

        <div class="flex-1"></div>

        <div class="relative z-10">
            <span class="text-[15px] leading-[1.5] text-white font-medium">Avaliar melhor. Decidir com precisão. Tratar com excelência. Prevenir com inteligência.</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AuthBrandingPanel',
    setup() {
        const highlights = [
            'Identifique fatores de risco antes da lesão',
            'Padronize suas avaliações clínicas',
            'Acompanhe a evolução ao longo do tempo',
            'Gere relatórios estratégicos automaticamente',
            'Inteligência artificial para apoiar decisões clínicas',
            'Baseado nas melhores evidências científicas'
        ];

        const cols = 5;
        const rows = 5;
        const cellW = 80;
        const cellH = 70;
        const gap = 6;
        const originX = 40;
        const originY = 30;
        const matrixCells = [];
        for (let r = 0; r < rows; r++) {
            for (let c = 0; c < cols; c++) {
                const risk = ((rows - 1 - r) + c) / (rows - 1 + cols - 1);
                matrixCells.push({
                    x: originX + c * (cellW + gap),
                    y: originY + r * (cellH + gap),
                    w: cellW,
                    h: cellH,
                    o: 0.05 + risk * 0.35
                });
            }
        }

        return { highlights, matrixCells };
    }
}
</script>
